import { getActiveWindow } from 'vscode/vscode/vs/base/browser/dom';
import { StandardMouseEvent } from 'vscode/vscode/vs/base/browser/mouseEvent';
import { Action, Separator } from 'vscode/vscode/vs/base/common/actions';
import { isNative } from 'vscode/vscode/vs/base/common/platform';
import { localizeWithPath } from 'vscode/vscode/vs/nls';

const _moduleId = "vs/workbench/contrib/terminalContrib/find/browser/textInputContextMenu";
function openContextMenu(targetWindow, event, clipboardService, contextMenuService) {
    const standardEvent = ( (new StandardMouseEvent(targetWindow, event)));
    const actions = [];
    actions.push(
    (
    (new Action('undo', ( localizeWithPath(_moduleId, 0, "Undo")), undefined, true, async () => getActiveWindow().document.execCommand('undo')))), ( (new Action('redo', ( localizeWithPath(_moduleId, 1, "Redo")), undefined, true, async () => getActiveWindow().document.execCommand('redo')))), ( (new Separator())),
    (
    (new Action('editor.action.clipboardCutAction', ( localizeWithPath(_moduleId, 2, "Cut")), undefined, true, async () => getActiveWindow().document.execCommand('cut')))), ( (new Action('editor.action.clipboardCopyAction', ( localizeWithPath(_moduleId, 3, "Copy")), undefined, true, async () => getActiveWindow().document.execCommand('copy')))), ( (new Action('editor.action.clipboardPasteAction', ( localizeWithPath(_moduleId, 4, "Paste")), undefined, true, async (element) => {
        if (isNative) {
            getActiveWindow().document.execCommand('paste');
        }
        else {
            const clipboardText = await clipboardService.readText();
            if (element instanceof HTMLTextAreaElement ||
                element instanceof HTMLInputElement) {
                const selectionStart = element.selectionStart || 0;
                const selectionEnd = element.selectionEnd || 0;
                element.value = `${element.value.substring(0, selectionStart)}${clipboardText}${element.value.substring(selectionEnd, element.value.length)}`;
                element.selectionStart = selectionStart + clipboardText.length;
                element.selectionEnd = element.selectionStart;
            }
        }
    }))), ( (new Separator())),
    (
    (new Action('editor.action.selectAll', ( localizeWithPath(_moduleId, 5, "Select All")), undefined, true, async () => getActiveWindow().document.execCommand('selectAll')))));
    contextMenuService.showContextMenu({
        getAnchor: () => standardEvent,
        getActions: () => actions,
        getActionsContext: () => event.target,
    });
}

export { openContextMenu };
